'use client';
import React from 'react';
import LanguageSwitcher from '@/components/language/LanguageSwitcher';
import { useLanguage } from '@/components/language/LanguageProvider';

export default function Footer() {
  const { dictionary } = useLanguage();

  return (
    <footer className="bg-[#080808] border-t border-white/[0.05] py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-5">
          {/* Left: Brand */}
          <div className="flex items-center gap-3 flex-wrap justify-center">
            <div className="w-6 h-6 rounded-full bg-primary/15 border border-primary/25 flex items-center justify-center">
              <svg width="9" height="9" viewBox="0 0 16 16" fill="none">
                <path d="M8 1L10 6H14L11 9.5L12 14L8 11.5L4 14L5 9.5L2 6H6L8 1Z" fill="#C8A96E" />
              </svg>
            </div>
            <span className="text-foreground/90 font-bold text-sm tracking-tight">
              juga<span className="text-primary">_</span>tattoo
            </span>
            <span className="text-muted-foreground/60 text-xs w-full text-center md:w-auto md:text-left">
              {dictionary.footer.location}
            </span>
          </div>

          {/* Center: Links */}
          <nav className="flex items-center justify-center flex-wrap gap-1 text-xs text-muted-foreground">
            {[
              { label: dictionary.footer.nav.portfolio, href: '#portfolio' },
              { label: dictionary.footer.nav.about, href: '#about' },
              { label: dictionary.footer.nav.book, href: '#booking' },
            ]?.map((link) => (
              <a
                key={link?.href}
                href={link?.href}
                className="px-3 py-1.5 rounded-lg hover:text-primary hover:bg-white/[0.04] transition-all duration-200 font-medium"
              >
                {link?.label}
              </a>
            ))}
          </nav>

          {/* Right: Social + Copyright */}
          <div className="flex items-center justify-center flex-wrap gap-2 sm:gap-4 text-xs text-muted-foreground/70">
            <LanguageSwitcher compact />
            <a
              href="https://www.instagram.com/juga_tattoo/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors flex items-center gap-1.5 font-medium"
              aria-label="Instagram @juga_tattoo"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
              </svg>
              @juga_tattoo
            </a>
            <span className="text-white/10">·</span>
            <span>© 2026</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
